// Em dev: proxy do Vue CLI intercepta /chatwoot-api → chatwoot.isbet.org.br (evita CORS)
// Em produção: nginx faz proxy de /chatwoot-api → chatwoot.isbet.org.br (ver nginx.conf)
export const CHATWOOT_BASE = '/chatwoot-api'

// WebSocket (ActionCable) do Chatwoot — conexão DIRETA à origem real, não passa
// pelo proxy /chatwoot-api acima (confirmado na Fase 0 do plano de tempo real,
// docs/planos/PLANO-REALTIME-ACTIONCABLE.md: a origem desta dashboard não é
// rejeitada pelo ActionCable, então não precisou de proxy pra isso).
export const CHATWOOT_CABLE_URL = 'wss://chatwoot.isbet.org.br/cable'

export function authHeaders(token: string): Record<string, string> {
  return { 'api_access_token': token }
}
